import { useState } from 'react';

type UseAsyncReturn = {
  run: <T>(fn: () => Promise<T>) => Promise<T>;
  isLoading: boolean;
};

export const useAsync = (): UseAsyncReturn => {
  const [isLoading, setIsLoading] = useState(false);

  const run = async <T>(fn: () => Promise<T>): Promise<T> => {
    setIsLoading(true);
    try {
      return await fn();
    } finally {
      setIsLoading(false);
    }
  };

  return { run, isLoading };
};
